<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>体验卡管理 / 新增</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="form-wrapper">
         <el-form label-width="80px" label-position="left" :model="formData" :rules="formRules" ref="formRef">
            <el-form-item label="名称" prop="name">
               <el-input placeholder="请输入名称" v-model="formData.name">
               </el-input>
            </el-form-item>
            <el-form-item label="特权角色" prop="privilegeRoleId">
               <el-select placeholder="请选择特权角色" filterable v-model="formData.privilegeRoleId">
                  <el-option v-for="(item, index) in privilegeOptions" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="体验时长" prop="duration">
               <el-input-number :controls="false" :min="0" :step="1" v-model="formData.duration"></el-input-number>
               <span>天</span>
            </el-form-item>
            <el-form-item label="有效期" prop="timeType">
               <el-radio-group v-model="formData.timeType" @change="changeTimeType">
                  <el-radio :label="1">固定</el-radio>
                  <el-radio :label="2">不固定</el-radio>
               </el-radio-group>
               <div v-if="formData.timeType == 1" class="flex-row">
                  <el-date-picker type="datetime" placeholder="起始日期" v-model="formData.startTime">
                  </el-date-picker>
                  <div>&nbsp;至&nbsp;</div>
                  <el-date-picker type="datetime" placeholder="结束日期" v-model="formData.endTime">
                  </el-date-picker>
               </div>
               <div v-else class="flex-row">
                  <span class="margin-right-10">获得后</span>
                  <el-input-number :controls="false" :min="0" :step="1" v-model="formData.effectTime"></el-input-number>
                  <span class="margin-left-10">天内有效</span>
               </div>
            </el-form-item>
            <el-form-item label="库存数量" prop="quantity">
               <el-radio-group v-model="quantityType" @change="changeQuantityType">
                  <el-radio :label="1">有限</el-radio>
                  <el-radio :label="0">无限</el-radio>
               </el-radio-group>
               <div class="flex-row" v-if="quantityType">
                  <el-input v-model="formData.quantity" @input="inputQuantity"></el-input>
                  <span class="margin-left-10">张</span>
               </div>
            </el-form-item>
         </el-form>
      </div>

      <div class="margin-20">
         <el-button type="primary" @click="clickSave()">保存</el-button>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      const validTimePeriod = (rule, value, callback) => {
         if (this.formData.timeType == 1) {
            if (!this.formData.startTime || !this.formData.endTime) {
               return callback(new Error("请选择有效期"));
            }
            if (this.formData.startTime > this.formData.endTime) {
               return callback(new Error("起始时间不能大于结束时间"));
            }
         } else if (this.formData.timeType == 2) {
            if (!this.formData.effectTime) {
               return callback(new Error("请输入有效天数"));
            }
         }

         callback();
      };
      const validQuantity = (rule, value, callback) => {
         if (this.quantityType == 1) {
            if (!this.formData.quantity || this.formData.quantity < 0) {
               return callback(new Error("请输入有效库存数量"));
            }
         }
         callback();
      };
      return {
         loading: false,
         formData: {
            name: "", // 名称
            privilegeRoleId: "", //特权角色
            duration: 0, // 使用时长（天）
            timeType: 1, // 有效期类型 1 固定 2 不固定
            effectTime: 0, // 有效期天数
            startTime: '', // 有效期开始时间
            endTime: '', // 有效期结束时间
            quantity: 0, // 数量 -1 无限制
            residualQuantity: 0, // 剩余数量(暂无用)
            status: 1, // 状态（1-已发布 2-撤销发布）
         },
         formRules: {
            name: { required: true, message: "请输入名称", trigger: "blur" },
            privilegeRoleId: { required: true, message: "请选择特权角色", trigger: "change" },
            duration: { type: 'number', required: true, message: "请输入体验时长", trigger: "blur" },
            timeType: { required: true, validator: validTimePeriod, trigger: "blur" },
            quantity: { required: true, validator: validQuantity, trigger: "blur" },
         },
         id: '',
         privilegeOptions: [],
         quantityType: 1,
      }
   },

   created() {
      this.queryPrivilegeRoles();
   },

   mounted() {
      const queryInfo = this.$route.query;
      if (queryInfo.actionType == 'edit') {
         this.handleDetailInfo();
      }
   },

   methods: {
      // 查询全部特权角色
      queryPrivilegeRoles() {
         this.$http({
            url: this.$util.domain + "/adminapi/privilege/v1/queryAll",
            method: "GET",
         }).then((res) => {
            const content = res.body.data || [];
            this.privilegeOptions = content.map((item) => ({
               label: item.name,
               value: `${item.id}`
            }));
         }).catch((err) => {
            this.privilegeOptions = [];
         })
      },
      // 查询详情信息
      handleDetailInfo() {
         const detailInfo = this.$util.getStore('experience-card-list-item');
         this.$util.removeStore('experience-card-list-item');

         const data = JSON.parse(detailInfo);
         this.id = data.id;
         this.formData.name = data.name;
         this.formData.privilegeRoleId = data.privilegeRoleId + '';
         this.formData.duration = data.duration;
         this.formData.timeType = data.timeType;
         this.formData.effectTime = data.effectTime;
         this.formData.startTime = data.startTime ? new Date(data.startTime) : '';
         this.formData.endTime = data.endTime ? new Date(data.endTime) : '';
         this.formData.quantity = data.quantity;
         this.quantityType = data.quantity == -1 ? 0 : 1;
         this.formData.residualQuantity = data.residualQuantity;
         this.formData.status = data.status;
      },
      // 发送信息
      sendInfo() {
         let params = {
            ...this.formData,
            residualQuantity: Math.max(this.formData.quantity, 0),
            startTime: new Date(this.formData.startTime).getTime(),
            endTime: new Date(this.formData.endTime).getTime(),
         };
         if (this.id) {
            params['id'] = this.id;
         }
         this.loading = true;
         this.$http({
            url: this.$util.domain + "/adminapi/experienceCard/addOrEdit",
            method: "POST",
            dataType: "json",
            body: JSON.stringify(params)
         }).then((res) => {
            if (res.body.error === 10000) {
               this.$router.go(-1);
            } else {
               this.$util.errorMsg(res.body.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         });
      },
      // 切换有效期类型
      changeTimeType() {
         if (this.formData.timeType == 1) { // 固定
            this.formData.effectTime = 0
         } else if (this.formData.timeType == 2) { // 不固定
            this.formData.startTime = ''
            this.formData.endTime = ''
         }
      },
      //  切换库存类型
      changeQuantityType() {
         if (this.quantityType == 1) { // 有限
            this.formData.quantity = 0
         } else if (this.quantityType == 0) { // 无限
            this.formData.quantity = -1
         }
      },
      // 输入库存数量
      inputQuantity(value) {
         const num = Number(value) || 0;
         this.formData.quantity = num > 0 ? num : 0;
      },
      // 点击保存
      clickSave() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               this.sendInfo();
            }
         });
      }
   }
}
</script>

<style scoped>
.valid-period .el-input {
   width: 100%;
}
</style>


// WEBPACK FOOTER //
// ExperienceCardDetail.vue?343d47ce